import React from 'react';

const FeatureItem = ({ children }) => {
  return (
    <li className="flex gap-3 items-start">
      <div className="flex justify-center items-center mt-0.5 w-6 h-6 bg-gray-900 rounded-full flex-shrink-0">
        <i className="ti ti-check text-sm text-white" />
      </div>
      <p className="text-base font-medium text-gray-900 max-md:text-base">
        {children}
      </p>
    </li>
  );
};

export default FeatureItem;
